module.exports = __webpack_public_path__ + "static/media/loader-gif.be115add.gif";